module.exports = __webpack_public_path__ + "static/media/arts_6.62bb789e.jpg";